import { Modal } from '@scuf/common';
import React from 'react';
import { toast, Zoom } from 'react-toastify';
import { BREAKPOINTS } from '../../constants/constants';
import useWindowSize from '../../utils/useWindowSize';
import FeedbackCard from '../FeedbackCard/FeedbackCard';
import { Snackbar } from '../Snackbar/Snackbar';
import './FeedbackModal.scss';
import { getMessage } from '../../message/utils';
interface IFeedbackModalProps {
    open: boolean;
    onClose: Function;
}

const FeedbackModal = (props: IFeedbackModalProps) => {
    const {width} = useWindowSize();
    const rejectToastMsg: string = getMessage('app.header.menu.help.toastmsg');
    const showLargeModal: boolean = width && width < BREAKPOINTS.MD ? true : false;
    const closeFeedbackPopup = (showSnackbar?: boolean) => {
        if (showSnackbar) {
          toast(<Snackbar toastMessage={rejectToastMsg} />, { position: 'bottom-right', className: 'fi-toast--snackbar', bodyClassName: 'fi-toast__body--snackbar', transition: Zoom, closeOnClick: true });
        }
        props.onClose();
      }
    return (
        <Modal 
            size={showLargeModal ? 'large' : 'small'} 
            open={props.open} 
            onClose={() => props.onClose()} 
            className='modal-fi feedback-modal'
            closeOnDimmerClick={false}
            closeOnDocumentClick={false}
        >
            <FeedbackCard onClose={closeFeedbackPopup} />
        </Modal>
    )
}

export default FeedbackModal;